export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  imageSeq: string;
  tags: string[];
}

export interface Category {
  id: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    id: 'boundary',
    name: '母子边界模糊',
    description: '探讨母子关系中边界意识缺失的表现、成因及重建健康边界的专业方法',
    icon: 'ri-shield-line',
  },
  {
    id: 'dependency',
    name: '母子情感依赖',
    description: '分析母子间过度情感依赖的心理机制，帮助建立独立而亲密的关系模式',
    icon: 'ri-heart-pulse-line',
  },
  {
    id: 'attachment',
    name: '依恋障碍',
    description: '深入解析依恋理论在母子关系中的应用，识别与修复不安全型依恋',
    icon: 'ri-mental-health-line',
  },
  {
    id: 'mental-health',
    name: '亲子关系心理健康',
    description: '关注亲子关系中的心理健康指标，提供科学的评估与维护方案',
    icon: 'ri-brain-line',
  },
  {
    id: 'intervention',
    name: '母子关系干预',
    description: '提供实证有效的心理干预策略，帮助家庭修复母子关系中的问题',
    icon: 'ri-hand-heart-line',
  },
  {
    id: 'counseling',
    name: '家庭心理咨询',
    description: '介绍家庭心理咨询的流程与方法，为需要专业帮助的家庭提供指导',
    icon: 'ri-chat-smile-2-line',
  },
];

export const articles: Article[] = [
  {
    slug: 'mother-kiss-son-psychological-analysis',
    title: '妈妈主动索吻儿子：是爱还是心理疾病的信号？',
    excerpt: '当母亲频繁主动向儿子索吻，这种行为背后可能隐藏着怎样的心理机制？本文从专业心理学角度分析过度亲密行为的成因与边界。',
    content: '',
    category: 'boundary',
    author: '林婉清',
    date: '2026-07-15',
    readTime: '8分钟',
    imageSeq: 'article-kiss-01',
    tags: ['母子边界', '亲密行为', '心理分析'],
  },
  {
    slug: 'mother-son-boundary-awareness',
    title: '母子边界意识：如何在爱与独立之间找到平衡',
    excerpt: '健康的母子关系需要清晰的边界意识。本文探讨如何在不伤害感情的前提下，建立并维护母子间的健康边界。',
    content: '',
    category: 'boundary',
    author: '陈思远',
    date: '2026-07-10',
    readTime: '10分钟',
    imageSeq: 'article-boundary-02',
    tags: ['边界意识', '母子关系', '独立成长'],
  },
  {
    slug: 'excessive-physical-intimacy-mother-son',
    title: '过度身体接触：母子亲密行为的红线在哪里？',
    excerpt: '身体接触是亲子关系的重要组成部分，但过度则可能影响孩子的心理发展。本文帮助家长识别亲密行为的合理限度。',
    content: '',
    category: 'boundary',
    author: '林婉清',
    date: '2026-06-28',
    readTime: '7分钟',
    imageSeq: 'article-touch-03',
    tags: ['身体接触', '亲密限度', '心理发展'],
  },
  {
    slug: 'mother-son-emotional-dependency-signs',
    title: '母子情感依赖的7个危险信号，你中了几个？',
    excerpt: '情感依赖不同于健康的亲密关系。本文列举7个需要警惕的母子情感依赖信号，并提供自我评估指南。',
    content: '',
    category: 'dependency',
    author: '王雅婷',
    date: '2026-07-20',
    readTime: '9分钟',
    imageSeq: 'article-dependency-04',
    tags: ['情感依赖', '危险信号', '自我评估'],
  },
  {
    slug: 'enmeshment-mother-son-relationship',
    title: '纠缠型母子关系：当妈妈把儿子当作情感伴侣',
    excerpt: '纠缠型关系是一种病态的家庭互动模式，母亲将儿子视为情感替代伴侣。本文深度分析这一现象的成因与危害。',
    content: '',
    category: 'dependency',
    author: '陈思远',
    date: '2026-07-05',
    readTime: '11分钟',
    imageSeq: 'article-enmesh-05',
    tags: ['纠缠关系', '情感替代', '家庭治疗'],
  },
  {
    slug: 'separation-individuation-mother-son',
    title: '分离个体化：帮助母子走出情感共生的专业路径',
    excerpt: '分离个体化是每个孩子成长的必经之路，但在过度依赖的母子关系中尤为困难。本文提供可操作的分离策略。',
    content: '',
    category: 'dependency',
    author: '王雅婷',
    date: '2026-06-20',
    readTime: '10分钟',
    imageSeq: 'article-separate-06',
    tags: ['分离个体化', '情感共生', '成长路径'],
  },
  {
    slug: 'attachment-theory-mother-son',
    title: '依恋理论入门：理解母子关系的底层心理密码',
    excerpt: '依恋理论是理解母子关系最重要的心理学框架之一。本文用通俗语言讲解依恋类型及其对亲子关系的影响。',
    content: '',
    category: 'attachment',
    author: '林婉清',
    date: '2026-08-01',
    readTime: '12分钟',
    imageSeq: 'article-attach-07',
    tags: ['依恋理论', '心理密码', '关系模式'],
  },
  {
    slug: 'insecure-attachment-mother-son-repair',
    title: '不安全型依恋的修复：重建母子安全连接的实操指南',
    excerpt: '不安全依恋并非不可改变。本文基于依恋修复理论，提供具体的改善策略帮助重建母子间的安全连接。',
    content: '',
    category: 'attachment',
    author: '陈思远',
    date: '2026-07-25',
    readTime: '13分钟',
    imageSeq: 'article-repair-08',
    tags: ['不安全依恋', '修复策略', '安全连接'],
  },
  {
    slug: 'childhood-attachment-adult-relationships',
    title: '童年母子依恋如何影响成年后的人际关系',
    excerpt: '童年的母子依恋模式会深远影响个体成年后的亲密关系、社交能力和情绪调节。本文追溯这种影响的内在机制。',
    content: '',
    category: 'attachment',
    author: '王雅婷',
    date: '2026-07-12',
    readTime: '9分钟',
    imageSeq: 'article-adult-09',
    tags: ['童年依恋', '成年关系', '长期影响'],
  },
  {
    slug: 'healthy-mother-son-relationship-guide',
    title: '健康母子关系养成指南：从婴幼儿到青春期的全程陪伴',
    excerpt: '不同年龄段的孩子需要不同的母子互动方式。本文按年龄阶段提供建立健康母子关系的完整指引。',
    content: '',
    category: 'mental-health',
    author: '林婉清',
    date: '2026-08-05',
    readTime: '15分钟',
    imageSeq: 'article-healthy-10',
    tags: ['健康成长', '分龄指导', '全程陪伴'],
  },
  {
    slug: 'mother-son-relationship-psychological-assessment',
    title: '母子关系心理评估：你的亲子关系健康吗？',
    excerpt: '提供专业的母子关系心理健康评估框架，帮助家长自我检测关系质量并识别潜在问题。',
    content: '',
    category: 'mental-health',
    author: '陈思远',
    date: '2026-07-18',
    readTime: '6分钟',
    imageSeq: 'article-assess-11',
    tags: ['心理评估', '关系质量', '自我检测'],
  },
  {
    slug: 'father-role-mother-son-dynamic',
    title: '父亲角色的重要性：第三方力量如何优化母子关系',
    excerpt: '父亲在母子关系中扮演着不可替代的调节角色。本文分析父亲参与如何促进健康的母子互动。',
    content: '',
    category: 'mental-health',
    author: '王雅婷',
    date: '2026-06-25',
    readTime: '8分钟',
    imageSeq: 'article-father-12',
    tags: ['父亲角色', '家庭动力', '三方关系'],
  },
  {
    slug: 'cognitive-behavioral-intervention-mother-son',
    title: '认知行为干预在母子关系修复中的应用',
    excerpt: '认知行为疗法（CBT）是母子关系干预中常用的实证方法。本文介绍CBT的核心技术及其在家庭场景中的具体操作。',
    content: '',
    category: 'intervention',
    author: '林婉清',
    date: '2026-07-30',
    readTime: '11分钟',
    imageSeq: 'article-cbt-13',
    tags: ['认知行为', '关系修复', '心理干预'],
  },
  {
    slug: 'family-system-therapy-mother-son',
    title: '家庭系统治疗视角下的母子关系重塑',
    excerpt: '家庭系统治疗将母子关系置于整个家庭系统中理解。本文探讨系统干预如何带来持久的关系改变。',
    content: '',
    category: 'intervention',
    author: '陈思远',
    date: '2026-07-08',
    readTime: '10分钟',
    imageSeq: 'article-system-14',
    tags: ['系统治疗', '关系重塑', '家庭动力'],
  },
  {
    slug: 'mindfulness-mother-son-relationship',
    title: '正念养育：用觉察力改善母子互动质量',
    excerpt: '正念技术可以帮助母亲提升对自身情绪和行为的觉察，从而改善与儿子的互动质量。本文提供可操作的正念练习。',
    content: '',
    category: 'intervention',
    author: '王雅婷',
    date: '2026-06-15',
    readTime: '7分钟',
    imageSeq: 'article-mindful-15',
    tags: ['正念养育', '觉察力', '互动质量'],
  },
  {
    slug: 'when-to-seek-family-counseling',
    title: '什么时候需要寻求家庭心理咨询？10个不容忽视的预警信号',
    excerpt: '很多家庭在关系问题已经严重时才寻求帮助。本文列出10个需要专业介入的预警信号，帮助及早识别问题。',
    content: '',
    category: 'counseling',
    author: '林婉清',
    date: '2026-08-08',
    readTime: '9分钟',
    imageSeq: 'article-counsel-16',
    tags: ['心理咨询', '预警信号', '专业帮助'],
  },
  {
    slug: 'choosing-family-therapist-guide',
    title: '如何选择合适的家庭心理咨询师：一份完整的筛选指南',
    excerpt: '找到匹配的心理咨询师是治疗成功的关键。本文提供选择家庭心理咨询师的专业建议和筛选题纲。',
    content: '',
    category: 'counseling',
    author: '陈思远',
    date: '2026-07-22',
    readTime: '8分钟',
    imageSeq: 'article-therapist-17',
    tags: ['咨询师选择', '治疗匹配', '筛选指南'],
  },
  {
    slug: 'online-vs-offline-family-counseling',
    title: '线上 vs 线下家庭心理咨询：哪种更适合你的家庭？',
    excerpt: '线上心理咨询的兴起为家庭提供了更多选择。本文对比两种咨询形式的优劣，帮助做出适合的决定。',
    content: '',
    category: 'counseling',
    author: '王雅婷',
    date: '2026-06-30',
    readTime: '6分钟',
    imageSeq: 'article-online-18',
    tags: ['线上咨询', '线下咨询', '形式对比'],
  },
];

export const testimonials = [
  {
    id: 1,
    name: '李女士',
    role: '10岁男孩的母亲',
    content: '通过这个平台的文章，我第一次意识到自己和儿子之间的边界问题。按照文章中的建议调整后，我和儿子的关系变得更加健康了。感谢这些专业的心理学知识！',
    rating: 5,
  },
  {
    id: 2,
    name: '张先生',
    role: '心理学教育工作者',
    content: '作为一名心理学教师，我非常认可这个平台内容的专业性和科学性。文章深入浅出，既适合专业人士参考，也适合普通家长阅读学习。',
    rating: 5,
  },
  {
    id: 3,
    name: '王女士',
    role: '7岁男孩的母亲',
    content: '以前总觉得对儿子亲密是很正常的事，看了关于\"情感依赖\"的文章后才明白过度的依赖会伤害孩子。现在正在按照干预指南一步步改善，效果很明显。',
    rating: 5,
  },
  {
    id: 4,
    name: '赵先生',
    role: '家庭心理咨询师',
    content: '这个平台将复杂的心理学理论转化为大众能理解的文字，对于普及心理健康知识非常有价值。我经常推荐给我的来访者家属阅读。',
    rating: 4,
  },
  {
    id: 5,
    name: '刘女士',
    role: '两个男孩的母亲',
    content: '关于依恋理论的文章让我深受触动。原来童年时期的依恋关系会如此深远地影响孩子的一生。现在更加重视与孩子们建立安全型依恋了。',
    rating: 5,
  },
  {
    id: 6,
    name: '孙女士',
    role: '社区心理咨询师',
    content: '文章内容既有学术深度又通俗易懂，对于我们在社区做心理健康科普很有帮助。特别是关于家庭系统治疗的那几篇，非常有启发性。',
    rating: 5,
  },
];

export const faqItems = [
  {
    question: '妈妈主动索吻儿子属于心理疾病吗？',
    answer: '妈妈主动索吻儿子本身不一定是心理疾病，但需要关注行为的频率、方式以及背后的心理动机。如果这种行为伴随着过度依赖、缺乏边界感或替代伴侣的情感需求，则可能反映出更深层的心理问题，如依恋障碍或情感依赖。建议从行为模式整体评估，而非孤立地判断单一行为。',
  },
  {
    question: '母子之间什么样的亲密行为是正常的？',
    answer: '正常的母子亲密行为应遵循以下原则：尊重孩子的意愿和身体自主权、符合孩子的年龄发展阶段、不带有伴侣化的情感色彩、不干扰孩子的独立成长。例如，适度的拥抱、摸头、牵手通常属于正常范围，而带有强烈依赖性的频繁索吻、过度身体接触则需要引起注意。',
  },
  {
    question: '如何判断母子关系是否存在边界模糊？',
    answer: '可以从以下几个方面判断：母亲是否过度介入儿子的私人生活、是否难以接受儿子的独立和分离、是否将儿子作为情感倾诉的主要对象、是否忽视儿子的个人隐私需求、是否将儿子视为伴侣的替代。如果存在多项符合，建议进行专业心理评估。',
  },
  {
    question: '母子情感依赖会对孩子造成哪些长期影响？',
    answer: '长期的情感依赖可能造成：孩子独立能力发展受阻、成年后亲密关系模式扭曲、自我认同感薄弱、情绪调节能力不足、社交边界感缺失等问题。严重情况下可能导致焦虑症、抑郁症等心理健康问题。早期识别和干预非常重要。',
  },
  {
    question: '什么情况下需要寻求家庭心理咨询？',
    answer: '当母子关系问题已经影响到日常家庭功能、孩子的学校表现或社交发展、家庭成员的情绪健康时，建议寻求专业心理咨询。具体预警信号包括：持续的亲子冲突、明显的情绪困扰、社会功能受损、家庭沟通完全中断等。',
  },
  {
    question: '不安全的母子依恋可以修复吗？',
    answer: '可以。依恋模式虽然形成于早期，但并非不可改变。通过专业的心理干预，如依恋修复治疗、认知行为疗法、家庭系统治疗等方法，结合日常关系互动模式的持续调整，不安全依恋可以得到显著改善。关键是有改变的意愿和正确的引导。',
  },
  {
    question: '父亲在改善母子关系中扮演什么角色？',
    answer: '父亲在母子关系中扮演着关键的"第三方"调节角色。父亲的参与可以：帮助建立健康的家庭三角关系、为母子提供情感缓冲空间、作为边界维护的参照系、为儿子提供性别认同的榜样。父亲的积极介入对修复过度纠缠的母子关系效果显著。',
  },
  {
    question: '如何帮助孩子建立健康的身体边界意识？',
    answer: '帮助孩子建立身体边界意识可以从以下方面入手：从小教育孩子"我的身体我做主"的理念、尊重孩子说不的权利、不强迫孩子进行任何形式的身体接触（包括对亲人的亲吻拥抱）、通过绘本和游戏进行边界教育、家长以身作则展示健康的边界行为。',
  },
];

export interface ArticleContent {
  slug: string;
  sections: {
    heading: string;
    paragraphs: string[];
    listItems?: string[];
  }[];
  conclusion: string;
}

export const articleContents: Record<string, ArticleContent> = {
  'mother-kiss-son-psychological-analysis': {
    sections: [
      {
        heading: '行为现象描述',
        paragraphs: [
          '在心理咨询实践中，我们经常遇到这样的案例：一位母亲在儿子已经进入青春期后，仍然保持着幼年时期形成的亲密习惯——频繁索吻、过度拥抱、甚至要求同床共眠。这些行为在表面上看起来是母爱的表达，但从专业心理学角度来看，它们可能反映出更深层的心理问题。',
          '妈妈主动索吻儿子这一行为，需要放在母子关系发展的大背景中理解。婴幼儿时期，亲吻和身体接触是建立安全型依恋的重要方式。然而，随着孩子年龄增长，亲密行为的性质和频率应当随之调整。当这种调整未能正常发生时，就可能构成边界模糊的问题。',
        ],
      },
      {
        heading: '心理学成因分析',
        paragraphs: [
          '从依恋理论的角度看，过度亲密行为常常源于母亲自身的不安全依恋模式。如果母亲在童年时期经历了情感匮乏或被忽视，她可能会通过与儿子建立过度亲密的关系来补偿自身的情感需求。这种补偿机制在短期内能给母亲带来情感满足，但长期来看会阻碍孩子的独立发展。',
          '从家庭系统理论来看，当婚姻关系存在问题时，母亲可能会无意识地将儿子提升到"情感伴侣"的位置，通过从儿子那里获取在丈夫那里未能得到的情感满足。这种现象在心理学中被称为"情感乱伦"或"纠缠型关系"，虽然不涉及实际的身体侵犯，但对孩子的心理健康同样具有破坏性。',
        ],
        listItems: [
          '母亲自身的安全感缺失：需要通过儿子的亲密行为来确认自我价值',
          '婚姻关系不协调：将儿子作为情感替代品',
          '分离焦虑：难以接受孩子成长和独立',
          '原生家庭模式传承：模仿自己童年时期的家庭互动模式',
        ],
      },
      {
        heading: '对儿童心理发展的影响',
        paragraphs: [
          '长期处于边界模糊的母子关系中的男孩，可能出现以下心理发展问题：自我认同混乱——他们难以区分"自己"和"母亲"的界限；社交能力受损——在与同龄人建立关系时缺乏适当的边界感；情绪调节困难——由于过度依赖母亲的情绪反馈，难以独立管理自身情绪。',
          '进入青春期和成年后，这些问题可能进一步演变为亲密关系障碍。在恋爱关系中，他们可能要么过度依赖伴侣，要么对亲密关系产生恐惧和回避。部分案例中，成年男性会不自觉地寻找与母亲性格相似的伴侣，形成不健康的"妈宝男"模式。',
        ],
      },
      {
        heading: '专业干预策略',
        paragraphs: [
          '针对妈妈主动索吻等过度亲密行为，心理干预通常从几个层面展开。首先是认知重构——帮助母亲理解健康边界的重要性，认识到过度亲密行为对孩子发展的潜在伤害。其次是行为干预——制定具体的、可操作的边界建立计划。最后是情感处理——帮助母亲找到健康的情感满足渠道。',
          '家庭心理咨询在这种情况中尤为有效。通过系统性的家庭治疗，可以帮助整个家庭重新建立健康的关系模式。认知行为疗法（CBT）也被证明对改善边界模糊问题有效，它帮助母亲识别和改变维持过度亲密行为的不良认知。',
        ],
      },
    ],
    conclusion: '妈妈主动索吻儿子这一行为的核心问题不在于亲吻本身，而在于行为背后的心理动机和关系模式。健康的母子关系需要随着孩子的成长阶段不断调整。当亲密行为超出了孩子的年龄和意愿所能接受的范围时，就构成了需要专业干预的心理问题。及时寻求帮助，既能保护孩子的心理健康，也能帮助母亲实现个人成长。',
  },
  'mother-son-boundary-awareness': {
    sections: [
      {
        heading: '什么是健康的母子边界',
        paragraphs: [
          '健康的母子边界不是一个固定的标准，而是一个动态的、适应性的概念。它指的是母子之间既能保持情感亲密，又能尊重彼此独立性的关系状态。在理想情况下，母子边界会随着孩子的年龄增长而逐步调整和扩展。',
          '边界意识的核心是认识到"我"和"你"是两个独立的个体。母亲需要明白，孩子不是自己的延伸，而是一个拥有独立思想、情感和选择权的个体。同样，孩子也需要学习在保持亲密关系的同时维护自己的个人空间。',
        ],
      },
      {
        heading: '边界模糊的常见表现',
        paragraphs: [
          '母子边界模糊的表现形式多种多样，有些较为明显，有些则比较隐蔽。常见的表现包括：母亲随意进入儿子的房间不敲门、翻看儿子的私人日记或手机、干涉儿子的交友选择、在儿子面前哭诉婚姻问题、以及本文重点讨论的过度身体亲密行为。',
          '除了行为层面的表现，边界模糊还有情感层面的表现。例如，母亲将自身情绪状态完全寄托在儿子身上——"只要你开心妈妈就开心，你难过妈妈也难过"。这种情感共生看似是爱的表现，实际上剥夺了孩子发展独立情绪调节能力的机会。',
        ],
        listItems: [
          '物理边界缺乏：随意进入私人空间、过度身体接触',
          '信息边界缺乏：翻看隐私、监听交流',
          '决策边界缺乏：代替做选择、不尊重个人意愿',
          '情感边界缺乏：情绪共生、情感替代',
          '社交边界缺乏：干涉交友、限制社交活动',
        ],
      },
      {
        heading: '如何在爱与独立之间找到平衡',
        paragraphs: [
          '建立健康的母子边界并不意味着冷漠或疏离。相反，清晰的边界能让母子关系更加稳定和成熟。关键在于找到"连接"与"分离"之间的动态平衡。母亲可以在保持情感关爱的前提下，有意识地创造和尊重孩子的独立空间。',
          '实际操作中，可以从以下几个方面入手：首先是自我觉察，母亲需要识别自己哪些行为是出于孩子的需要，哪些是出于自身的需要；其次是逐步调整，边界建设不需要一蹴而就，可以从小处着手逐步推进；最后是保持沟通，让孩子理解这些变化背后的良苦用心。',
        ],
      },
    ],
    conclusion: '母子边界的建立是一门需要不断学习和调整的艺术。它需要母亲的自觉、孩子的配合、以及时间的沉淀。当健康的边界建立起来后，母子关系不会变得疏远，反而会变得更加真实、成熟和持久。',
  },
  'excessive-physical-intimacy-mother-son': {
    sections: [
      {
        heading: '身体接触在亲子关系中的作用',
        paragraphs: [
          '身体接触是亲子关系中最原始也最重要的沟通方式之一。从婴儿时期的抚触、拥抱到幼儿时期的牵手、亲吻，恰当的身体接触有助于建立安全感、促进情感交流和增强关系纽带。研究证实，充足且适当的身体接触对儿童的情绪发展和社交能力都有积极影响。',
          '然而，身体接触的健康作用有一个前提条件：它必须符合孩子的年龄发展阶段和个人意愿。随着孩子进入学龄期和青春期，身体接触的方式、频率和情境都需要相应调整。强迫或过度的身体接触，即便是出于"爱"的名义，也会对孩子的心理健康产生负面影响。',
        ],
      },
      {
        heading: '各年龄段的身体接触合理界限',
        paragraphs: [
          '0-3岁（婴幼儿期）：这个阶段的身体接触几乎不存在"过度"的问题。婴儿需要大量的身体接触来建立安全感。亲吻、拥抱、抚触都是正常且必要的。关键在于由孩子主导接触节奏，而非成人单方面决定。',
          '4-7岁（学龄前期）：孩子开始发展独立性，身体接触的频率自然降低。亲吻仍然常见，但应该开始关注孩子的意愿。可以培养用语言表达情感的能力，减少对身体接触的完全依赖。',
          '8-12岁（学龄期）：孩子对身体接触的接受度进一步降低，特别是当众场合。亲吻通常局限于脸颊，且应先征得同意。过度频繁的索吻可能在这个阶段开始显现出不健康的一面。',
          '13岁及以上（青春期）：身体接触的方式应有明显变化。频繁索吻——尤其是嘴对嘴亲吻——在这个年龄段应引起警惕。尊重青少年的身体自主权是建立健康关系的前提。',
        ],
        listItems: [
          '尊重孩子说"不"的权利，不将拒绝解读为不爱',
          '关注孩子的非语言信号（如退缩、僵硬、回避眼神）',
          '避免在公共场合进行让孩子感到尴尬的身体接触',
          '用多样化的方式表达爱（语言肯定、共度时光、给予尊重）',
        ],
      },
    ],
    conclusion: '母子之间的身体接触需要遵循"年龄适应性"和"孩子主导"两大原则。当母亲发现自己在不断寻求超出孩子接受范围的身体亲密时，这是需要自我反思和专业帮助的信号。健康的关系中，爱可以通过无数种方式表达，身体接触只是其中之一。',
  },
  'mother-son-emotional-dependency-signs': {
    sections: [
      {
        heading: '情感依赖与健康亲密的区别',
        paragraphs: [
          '情感依赖和健康亲密之间的界限有时非常微妙。健康的母子亲密关系以相互尊重和独立为基础，双方都是完整、自主的个体。而情感依赖则表现为一方过度依赖另一方来满足情感需求，失去了独立的情感调节能力。',
          '一个简单但有效的区分标准是：健康的亲密让人更有力量去探索世界，而情感依赖则限制人的独立发展。如果母子关系让双方——特别是孩子——感到被束缚而非被支持，那么很可能存在情感依赖的问题。',
        ],
      },
      {
        heading: '七个危险信号',
        paragraphs: [
          '以下是七个需要警惕的母子情感依赖信号。需要强调的是，偶尔出现其中的一两个并不一定构成问题，但如果多个信号同时存在且持续较长时间，则需要引起重视。',
        ],
        listItems: [
          '信号一：母亲是儿子的唯一情感倾诉对象——儿子在遇到困难时只能想到母亲，无法向其他人求助',
          '信号二：分离焦虑严重——即使短暂分开也会让一方或双方产生强烈的焦虑和不适',
          '信号三：母亲难以接受儿子的独立——对儿子的任何独立尝试表现出不满或阻拦',
          '信号四：情绪共生——母亲的情绪完全取决于儿子的状态，反之亦然',
          '信号五：社交限制——母亲限制儿子与同龄人的交往，尤其是在儿子有了亲密朋友之后',
          '信号六：伴侣化倾向——母亲将儿子当作情感伴侣，分享本应属于成人伴侣间的话题',
          '信号七：角色混淆——家庭中出现角色倒转，儿子承担了安抚母亲的成人角色',
        ],
      },
      {
        heading: '自我评估与初步应对',
        paragraphs: [
          '如果你发现自己或自己的家庭存在上述信号，首先不要恐慌。认识到问题是改变的第一步。可以尝试以下初步应对策略：记录一周内母子互动的模式和频率，客观看待关系状态；尝试进行小规模的分离练习，比如让其他家庭成员参与孩子的照顾；寻求可信赖的第三方（如好友、老师）的客观意见。',
          '如果自我调整效果有限，建议寻求专业的家庭心理咨询。专业咨询师能够提供更为系统化的评估和干预方案。',
        ],
      },
    ],
    conclusion: '情感依赖不是一天形成的，也不可能一天解决。它需要母亲的觉悟、孩子的配合、以及整个家庭系统的调整。但好消息是，只要有意愿和正确的方法，任何程度的情感依赖都可以逐步改善。',
  },
};

export const aboutInfo = {
  brandName: '母子关系心理健康指南',
  tagline: '以专业心理学知识守护每一个家庭的亲子关系健康',
  introduction: '我们是一个专注于亲子关系心理健康的内容平台，汇聚了多位拥有国家认证资质的心理咨询师和心理教育工作者。我们致力于将专业的心理学知识转化为通俗易懂、可操作的指导方案，帮助中国家庭建立健康、和谐的亲子关系。',
  mission: '我们的使命是通过科学的心理学内容传播，提升全社会对亲子关系心理健康的认识和重视。我们相信，每一个健康的亲子关系，都是孩子未来幸福生活的基础。',
  values: [
    { title: '专业严谨', description: '所有内容均由持证心理咨询师撰写或审核，确保科学性' },
    { title: '通俗易懂', description: '将复杂心理学理论转化为大众能理解的语言' },
    { title: '实用导向', description: '提供可操作的建议和策略，而非空谈理论' },
    { title: '包容接纳', description: '以非评判的态度对待每一个家庭的问题' },
  ],
  stats: [
    { label: '专业文章', value: '200+' },
    { label: '合作咨询师', value: '15+' },
    { label: '帮助家庭', value: '10,000+' },
    { label: '用户满意度', value: '98%' },
  ],
};

export const teamMembers = [
  {
    name: '林婉清',
    title: '首席心理咨询师',
    description: '国家二级心理咨询师，北京大学心理学硕士。专攻依恋理论与家庭系统治疗，拥有15年临床咨询经验。',
    imageSeq: 'team-01',
  },
  {
    name: '陈思远',
    title: '高级心理咨询师',
    description: '国家二级心理咨询师，中科院心理所博士。擅长认知行为治疗和亲子关系干预，发表多篇核心期刊论文。',
    imageSeq: 'team-02',
  },
  {
    name: '王雅婷',
    title: '家庭治疗师',
    description: '国家三级心理咨询师，华东师范大学应用心理学硕士。专注于正念养育和家庭沟通模式研究。',
    imageSeq: 'team-03',
  },
];